import styled, { css } from 'styled-components'

export const PostBody = styled.div`
  padding-bottom: ${({ theme }) => theme.rem(40)};
`

export const BodyTitle = styled.div`
  margin: ${({ theme }) => theme.rem(24, 0, 16, 0)};
`

export const BodyImage = styled.div`
  position: relative;
  margin: ${({ theme }) => theme.rem(24, 0)};
  margin-left: auto;
  margin-right: auto;
  aspect-ratio: 16 / 9;
  max-height: ${({ theme }) => theme.rem(500)};
  border-radius: ${({ theme }) => theme.rem(24)};
  overflow: hidden;

  img {
    object-fit: cover;
    object-position: center;
  }
`
